import { Flex } from "@chakra-ui/react";
import { FieldDef, IssueDetail } from "models/issue";
import { CheckSlackConnection } from "features/User/Components/Slack";
import { RedirectToSearchUsersButton } from "features/Issues/Components/Button/SlackResolutionButtons";
import { ResolutionInfo } from "models/resolutions";
import { UserUpdateFormValues } from "components/Forms/UserUpdateForm";
import UserFormFields from "features/Issues/Components/UserFormFields";
import { useMemo } from "react";

export function missingSlackUserIssueType(_: IssueDetail) {
  return "Missing Slack Account";
}

export function expandedMissingSlackUserIssueType(issue: IssueDetail) {
  if (issue?.user?.fullName) {
    return `Missing ${issue?.user?.fullName}'s Slack`;
  }
  return missingSlackUserIssueType(issue);
}

export function missingMessageServiceUserValue(issue: IssueDetail) {
  return issue?.user?.messageServiceId;
}

export function IssueModalInputFields({ issue }: { issue: IssueDetail }) {
  const fields: FieldDef<UserUpdateFormValues>[] = useMemo(() => (
    [{ name: "workEmail", label: "Work Email" }]
  ), []);
  return (
    <Flex direction="column" gap="4">
      {issue?.context?.userId && (
        <UserFormFields
          userId={issue.context.userId}
          fieldsDefs={fields}
          issue={issue}
        />
      )}
      <RedirectToSearchUsersButton />
      <CheckSlackConnection userId={issue?.context?.userId} />
    </Flex>
  );
}

export function missingMessageServiceUserResolution(issue: IssueDetail): ResolutionInfo {
  const { user } = issue || {};
  return ({
    issueType: "missing_message_service_user",
    tagText: missingSlackUserIssueType(issue),
    title: user?.fullName ? `Cannot find ${user?.fullName} in Slack` : "Cannot find user in Slack",
    additionalContext: `We use the Camino 'Work Email' to sync with Slack. We cannot find ${user?.firstName || "the user"}'s Slack account. Ensure the Slack email matches Camino's 'Work Email'.`,
    inputComponent: IssueModalInputFields,
  });
}
